<span class="sv-popup__pointer" [style]="{ left: popupModel.pointerTarget.left, top: popupModel.pointerTarget.top }"></span>